Ext.define('SA.view.SimpleContainer', {
    alias: 'widget.simple-container',
    extend: 'Ext.Component',
    mixins: ['SA.view.mixin.ChildItems', 'Ext.Queryable'],

    baseCls: 'sa-simple-container',
    items: [],

    initComponent() {
        this.items = this.initItems(this.items);

        this.callParent();
    },

    add(newItems) {
        return this.insert(this.items.length, newItems);
    },

    afterRender() {
        this.callParent();

        this.renderItems();
    },

    getChildItems() {
        return this.getChildItemsImpl();
    },

    getChildItemsImpl() {
        var items = this.items,
            index = items.length - 1;

        for ( ; index >= 0 ; --index) {
            if (items[index].isDestroyed) {
                items.splice(index, 1);
            }
        }

        return items;
    },

    initItems(items) {
        var me = this;

        return items.map(item => {
            if (!item.isComponent) {
                item = Ext.widget(item);
            }

            item.getRefOwner = function() {
                return me;
            };

            return item;
        });
    },

    insert(index, newItems) {
        var single = !Array.isArray(newItems),
            items = this.items = this.items.slice();

        if (single) {
            newItems = [newItems];
        }

        newItems = this.initItems(newItems);

        newItems.forEach(item => {
            var index = items.indexOf(item);

            if (index !== -1) {
                items.splice(index, 1);
            }
        });

        newItems.unshift(index, 0);

        items.splice.apply(items, newItems);

        this.renderItems();

        return single ? newItems[2] : newItems.slice(2);
    },

    onDestroy() {
        this.removeAll();

        this.callParent();
    },

    remove(item) {
        if (Array.isArray(item)) {
            Ext.destroy(item);
            this.items = this.getChildItems().filter(item => !item.isDestroyed);
            return;
        }

        var items = this.getChildItems(),
            index = items.indexOf(item);

        Ext.destroy(item);

        if (index !== -1) {
            items.splice(index, 1);
        }
    },

    removeAll() {
        Ext.destroy(this.getChildItems());

        this.items = [];
    },

    renderItems() {
        var el = this.el,
            lastDom = null;

        if (!el) {
            return;
        }

        this.getChildItemsImpl().forEach(item => {
            if (!item.rendered) {
                item.render(el);
            }

            var dom = item.el.dom;

            if (dom.previousSibling !== lastDom) {
                el.dom.insertBefore(dom, lastDom ? lastDom.nextSibling : el.dom.firstChild);
            }

            lastDom = dom;
        });
    },

    setItems(items) {
        this.removeAll();
        this.add(items);
    },

    syncItems(items) {
        var existingItems = this.getChildItems(),
            defunctItems = Ext.Array.difference(existingItems, items),
            newItems = Ext.Array.difference(items, existingItems);

        this.remove(defunctItems);
        this.add(newItems);
    }
});